module.exports = __webpack_public_path__ + "img/jacobs.081a8748.jpg";